import React from "react";
import { Col, Form } from "react-bootstrap";
import { orgUsers, retentionReport } from "../../api";
import "./report-one.scss";
import Select from "react-select";

const customStyles = {
    option: (provided, state) => ({
        ...provided,
        borderBottom: "1px solid #EAEBEF",
        padding: 10,
        fontSize: 14,
    }),
    control: (provided) => ({
        ...provided,
        width: "200px",
    }),
    menu: (provided) => ({
        ...provided,
        width: "200px",
    }),
};

const currentDate = new Date();
const previousMonthDate = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() - 1,
    1,
);
const previousToPreviousMonthDate = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() - 2,
    1,
);

const formatMonth = (date) => {
    const year = date.getFullYear();
    let month = date.getMonth() + 1;
    month = month < 10 ? "0" + month : month;
    return `${year}-${month}`;
};

const previousMonth = formatMonth(previousMonthDate);
const previousToPreviousMonth = formatMonth(previousToPreviousMonthDate);

class RetentionReport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOption: null,
            orgUsers: [],
            errorMessage: null,
            errorMessageForMonth2: null,
            compareMonth1: previousToPreviousMonth,
            compareMonth2: previousMonth,
            finalreport: null,
            menuCLose: true,
            loading: false,
        };
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.getOrgUsers = this.getOrgUsers.bind(this);
        this.handleReport = this.handleReport.bind(this);
    }

    componentDidMount() {
        this.getOrgUsers();
    }

    handleSelectChange = (selectedOption) => {
        this.setState({ selectedOption: selectedOption });
    };

    getOrgUsers = () => {
        orgUsers().then((res) => {
            this.setState({ orgUsers: res.users });
        });
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState((prev) => ({
            ...prev,
            [name]: value,
            errorMessage: null,
            errorMessageForMonth2: null,
        }));
    };

    handleReport = () => {
        const {
            selectedOption,
            orgUsers,
            errorMessage,
            errorMessageForMonth2,
            compareMonth1,
            compareMonth2,
        } = this.state;

        if (!compareMonth1) {
            this.setState({ errorMessage: "month1 is required" });
        } else if (!compareMonth2) {
            this.setState({ errorMessageForMonth2: "month2 is required" });
        } else if (compareMonth1 >= compareMonth2) {
            this.setState({
                errorMessage: "month1 cannot be greater than month2",
            });
        } else {
            this.setState({
                errorMessageForMonth2: null,
                errorMessage: null,
                loading: true,
            });
            const formData = new FormData();

            if (selectedOption?.value) {
                formData.append("team_lead", +selectedOption?.value);
            }
            formData.append("month_1", compareMonth1);
            formData.append("month_2", compareMonth2);

            retentionReport(formData)
                .then((response) => {
                    if (response.status_code === 200) {
                        this.setState((prev) => ({
                            ...prev,
                            finalreport: response,
                            loading: false,
                        }));
                    } else {
                        this.setState({
                            errorMessage: "Something went wrong",
                            loading: false,
                        });
                    }
                })
                .catch((error) => console.log(error));
        }
    };

    render() {
        const {
            selectedOption,
            orgUsers,
            compareMonth1,
            compareMonth2,
            errorMessage,
            errorMessageForMonth2,
            finalreport,
            menuCLose,
            loading,
        } = this.state;

        let teamleadList = orgUsers.map((item) => ({
            value: item.id.toString(),
            label: item.name,
        }));
        teamleadList.unshift({ value: "", label: "Select Team Lead" });
        return (
            <div className="page-bottom-wrap ">
                <div className="container-fluid">
                    <div className="report-wrapper">
                        <div className="report-form">
                            <Form autoComplete="off">
                                <Form.Row>
                                    <div className="compare-box-wrapper">
                                        <div className="compare-box">
                                            <Form.Group
                                                as={Col}
                                                xs={12}
                                                className="px-3"
                                            >
                                                <label>Compare month 1</label>
                                                <br />
                                                <Form.Control
                                                    type="month"
                                                    className="compare-month-1"
                                                    name="compareMonth1"
                                                    value={compareMonth1}
                                                    onChange={this.handleChange}
                                                />
                                                {errorMessage && (
                                                    <p className="error-msg">
                                                        {errorMessage}
                                                    </p>
                                                )}
                                            </Form.Group>

                                            <Form.Group
                                                as={Col}
                                                xs={12}
                                                className="px-3"
                                            >
                                                <label>Team lead</label>
                                                <br />
                                                <Select
                                                    styles={customStyles}
                                                    className={
                                                        menuCLose
                                                            ? "teamlead-filter bannkmodalselect"
                                                            : "active-teamlead"
                                                    }
                                                    options={teamleadList}
                                                    onChange={
                                                        this.handleSelectChange
                                                    }
                                                    value={selectedOption}
                                                    placeholder="Select Team Lead"
                                                    onMenuClose={(e) =>
                                                        this.setState({
                                                            menuCLose: true,
                                                        })
                                                    }
                                                    onMenuOpen={(e) =>
                                                        this.setState({
                                                            menuCLose: false,
                                                        })
                                                    }
                                                />
                                            </Form.Group>

                                            <Form.Group
                                                as={Col}
                                                xs={12}
                                                className="px-3"
                                            >
                                                <label>Compare month 2</label>
                                                <br />
                                                <Form.Control
                                                    type="month"
                                                    className="compare-month-2"
                                                    name="compareMonth2"
                                                    value={compareMonth2}
                                                    onChange={this.handleChange}
                                                />
                                                {errorMessageForMonth2 && (
                                                    <p className="error-msg">
                                                        {errorMessageForMonth2}
                                                    </p>
                                                )}
                                            </Form.Group>
                                        </div>

                                        <button
                                            type="button"
                                            onClick={(e) => this.handleReport()}
                                            className="btn confirm-button"
                                        >
                                            Submit
                                        </button>
                                    </div>
                                </Form.Row>
                            </Form>
                        </div>

                        {loading ? (
                            <div className="loader-wrap report-loader">
                                <p className="loader"> </p>
                            </div>
                        ) : finalreport ? (
                            <div className="report-box">
                                <div>
                                    <p>
                                        <strong>
                                            {finalreport?.month_1_label}
                                        </strong>
                                    </p>
                                    <p>{finalreport?.data_1_count}</p>
                                </div>

                                <div>
                                    <p>
                                        <strong>
                                            {finalreport?.month_2_label}
                                        </strong>
                                    </p>
                                    <p>{finalreport?.data_2_count}</p>
                                </div>

                                <div>
                                    <p>
                                        <strong>Retention %</strong>
                                    </p>
                                    <p
                                        className={
                                            finalreport?.retention_percent >=
                                            100
                                                ? "retention-success"
                                                : "retention-alert"
                                        }
                                    >
                                        {finalreport?.retention_percent}
                                    </p>
                                </div>
                            </div>
                        ) : (
                            ""
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default RetentionReport;
